"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AcTableRow_module_scss_1 = __importDefault(require("./AcTableRow.module.scss"));
exports.AcTableRow = function (props) {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h;
    var onRowClick = props.onRowClick, onRowDoubleClick = props.onRowDoubleClick, onRowExpand = props.onRowExpand, functionContext = props.functionContext, data = props.data, activeData = props.activeData, highlight = props.highlight, children = props.children;
    var trEl = react_1.useRef(null);
    var _j = react_1.useState(false), expandRow = _j[0], setExpandRow = _j[1];
    var buildHighlight = function () {
        if (!highlight) {
            return undefined;
        }
        var value;
        if (typeof highlight === 'function') {
            value = highlight(data || {}, functionContext || {});
        }
        else {
            value = highlight;
        }
        if (value === true)
            return 'default';
        if (value === false || value === undefined || !['default', 'warning'].includes(value))
            return undefined;
        return value;
    };
    var traverseToTr = function (el, elements) {
        if (el !== trEl.current) {
            if (el === null || el === void 0 ? void 0 : el.parentElement) {
                return elements.concat(el, traverseToTr(el.parentElement, elements));
            }
        }
        return elements;
    };
    var filterClickRow = function (elements) {
        var filterClassNames = ['dropdown', 'ac-table--no-row-click', 'fa-ellipsis-v-alt']; // TODO use specific class instead of fa-ellipsis-v-alt
        var filterElement = elements.find(function (el) {
            var filterClassName = filterClassNames.find(function (name) { return el.className.includes(name); });
            return !!filterClassName;
        });
        return !!filterElement;
    };
    var hasExpandRow = function (elements) {
        var filterClassNames = ['ac-table--expand-row'];
        var filterElement = elements.find(function (el) {
            var filterClassName = filterClassNames.find(function (name) { return el.className.includes(name); });
            return !!filterClassName;
        });
        return !!filterElement;
    };
    var onClickRow = function (e) {
        if (onRowExpand) {
            var elements = traverseToTr(e.target, []);
            if (hasExpandRow(elements)) {
                setExpandRow(!expandRow);
                return;
            }
        }
        if (onRowClick) {
            var elements = traverseToTr(e.target, []);
            onRowClick(data, functionContext, filterClickRow(elements));
        }
    };
    var onDoubleClickRow = function (e) {
        if (onRowDoubleClick) {
            var elements = traverseToTr(e.target, []);
            onRowDoubleClick(data, functionContext, filterClickRow(elements));
        }
    };
    // TODO refactor style.inCharge to use highlight callback
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", { id: "ac-table-row-" + ((_c = data) === null || _c === void 0 ? void 0 : _c.id), ref: trEl, className: clsx_1.default((_a = {
                    'table-active': ((_d = data) === null || _d === void 0 ? void 0 : _d.id) === ((_e = activeData) === null || _e === void 0 ? void 0 : _e.id),
                    'font-weight-bold': buildHighlight() === 'default'
                },
                _a[AcTableRow_module_scss_1.default.inCharge] = data.inCharge === 'MINE' &&
                    data.isDraftDocument !== true &&
                    data.isReceivedDocument === true,
                _a)), onClick: onClickRow, onDoubleClick: onDoubleClickRow }, children),
        expandRow && !!onRowExpand && (react_1.default.createElement("tr", { id: "ac-table-row-" + ((_f = data) === null || _f === void 0 ? void 0 : _f.id) + "-expand", className: clsx_1.default((_b = {
                    'table-active': ((_g = data) === null || _g === void 0 ? void 0 : _g.id) === ((_h = activeData) === null || _h === void 0 ? void 0 : _h.id),
                    'font-weight-bold': buildHighlight() === 'default'
                },
                _b[AcTableRow_module_scss_1.default.inCharge] = data.inCharge === 'MINE' &&
                    data.isDraftDocument !== true &&
                    data.isReceivedDocument === true,
                _b)), onClick: onClickRow, onDoubleClick: onDoubleClickRow }, onRowExpand(data, functionContext)))));
};
exports.AcTableRow.displayName = 'AcTableRow';
//# sourceMappingURL=AcTableRow.js.map